'use strict';

import type { Report } from '../../Entities/Reports/Report';
import { EntityCollection } from '../EntityCollection';

export class ReportCollection extends EntityCollection<Report> {}
